import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";

const HeroSection = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [keyword, setKeyword] = useState("");

  const handleUserInput = (e) => {
    setKeyword(e.target.value);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/search/${encodeURIComponent(keyword)}/all`);
  };

  return (
    <div className="flex flex-col items-center  justify-center  min-h-screen bg-hero-background bg-cover md:bg-center bg-no-repeat">
      {/* Web Name */}
      <div className="text-gray-700 text-center md:block hidden md:mt-6">
        <h1 className="text-7xl font-bold">Masakan Kekinian</h1>
        <h1 className="text-2xl font-semibold">{t("hero.tagline")}</h1>
      </div>
      {/* Search Bar */}
      <form onSubmit={handleSearch} className="w-full flex justify-center">
        <div className="relative rounded-2xl bg-white/70  p-3 md:w-96 w-4/5 mt-4 z-20">
          <input
            type="text"
            className="w-full bg-transparent outline-none text-gray-900"
            placeholder={t("hero.searchPlaceholder")}
            onChange={handleUserInput}
            required
          />
          <button
            type="submit"
            aria-label={t("hero.searchLabel")}
            className="absolute inset-y-0 right-0 flex items-center pr-3"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
              />
            </svg>
          </button>
        </div>
      </form>
      {/* End of Search Bar */}
    </div>
  );
};

export default HeroSection;
